import { useState, useEffect } from "react";
import { loadVendorEnquiryComparisionList } from "../../services/vendorEnquiryService";

const useVendorEnquiryComparisonList = () => {
    const [comparisonList, setComparisonList] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);

    const [selectedComparison, setSelectedComparison] = useState(null);
    const [selectedComparisonID, setSelectedComparisonID] = useState(null);

    const fetchVendorComparisonList = async (selectedID = null) => {
        const para = { 
            p_company_id: localStorage.getItem("companyid"),            
        };

        try {
            const data = await loadVendorEnquiryComparisionList(para);

            if (data && data.length > 0) {
                setComparisonList(data);

                const initialRow = data.find((x) => x.id_comparison === selectedID);

                if (initialRow) {
                    setSelectedComparison(initialRow);
                    setSelectedComparisonID(initialRow.id_comparison);
                }

                setIsLoaded(true);
            }
        } catch (error) {
            console.error("Vendor comparison load error:", error);
        }
    };

    // Auto load on mount
    useEffect(() => {
        if (!isLoaded ) {
            fetchVendorComparisonList();
        }
    }, [isLoaded]);

    // Load when user selects a row
    const loadComparisonByID = async (selectedID) => {
        await fetchVendorComparisonList(selectedID);
    };

    return {
        comparisonList,
        selectedComparison,
        selectedComparisonID,
        setSelectedComparison,
        setSelectedComparisonID,
        loadComparisonByID,
        reload: fetchVendorComparisonList,
    };
};

export default useVendorEnquiryComparisonList;
